<style scpoed >

.top-margin {
    margin-left: 5px
}

.user-info {
    color: #999999;
}

</style>

<template>

<list-template ref="list-template" :hasSearch="true" actionUrl="question/findUsers.action" :queryParams="searchInfo">
    <template slot="search" scope="scope">
        <el-col :span="4" >
            <el-input type="primary" v-model="searchInfo.keyword" placeholder="昵称/手机号" clearable></el-input>
        </el-col>
        <el-col :span="4">
            <el-select  v-belong-to-admin v-model="searchInfo.channelId" @change="$refs['list-template'].search()" clearable filterable placeholder="筛选来源">
                <el-option :label="channelOption.channelName" v-for="channelOption in showChannels" :value="channelOption.id"></el-option>
            </el-select>
        </el-col>

        <el-col :span="8">
            <el-date-picker type="datetimerange"  v-model="startEndTime" start-placeholder="开始时间" placeholder="按发布时间筛选" end-placeholder="结束时间" @change="onTimeChange">
            </el-date-picker>
        </el-col>
    </template>

    <template slot="item" scope="scope">
        <div>
            <el-card class="basic-margin" v-for="data in scope.datas">
                <el-row>
                    <img :src="data.userHead " style="width:100px;height:100px;float:left;border-radius:80px;">
                    <el-col :span="6" style="padding:0px;padding-left:20px;">
                        <p><span style="font-size:20px;"><b>{{data.phone==""?"手机号暂无":data.phone}}</b><el-tag size="mini" v-bind:style="{marginLeft:'20px',color:data.del==1?'#67C23A':'#F56C6C'}">{{data.del==1?'启用':'停用'}} </el-tag><el-tag v-if="data.inviterUserNickname" style="margin-left: 20px;" size="mini"type="success">邀请人：{{data.inviterUserNickname}}</el-tag></span></p>

                        <p><span class="user-info">用户昵称：</span>{{data.nickname}}</p>
                        <p><span class="user-info">来源：</span>{{data.channelName}}</p>

                        <p><span class="user-info">注册时间：</span>{{data.createTime | dateTimeFormat }}</p>
                        <p><span class="user-info">最近活跃：</span>{{data.loginTime | dateTimeFormat }}</p>

                    </el-col>
                    <el-col :span="4" style="padding-left:40px;margin-top: 40px;">
                        <p><span class="user-info">累计收入：</span> {{data.coinTotalCount?data.coinTotalCount:0}} 汽车币</p>
                        <p><span class="user-info">累计提现：</span> {{data.coinConsumeCout?data.coinConsumeCout:0}} 汽车币</p>
                        <p><span class="user-info">当前余额：</span> {{data.canUseCoinCount?data.canUseCoinCount:0}} 汽车币</p>

                    </el-col>

                    <el-col  v-if="isAdmin" :span="6" style="padding-left:40px;margin-top: 20px;">
                      <el-button style="color:#000000;" @click="$router.push({name:'查看明细',params:{id:data.id}})" type="text">查看明细</el-button>
                      <el-button style="color:#409EFF;" @click="$router.push({name:'邀请列表',params:{id:data.id}})" type="text">查看邀请列表</el-button>
                        <el-button v-if="data.del==1" style="color:#F56C6C;" v-confirm :confirm-text="'确定停用账号？停用后，该用户不能登录汽车网，不能发布信息等。 '+data.nickname+'('+data.phone+') ?'" requestUrl="question/disabledUser.action" :confirm-data="{id:data.id,del:2}" @onConfirm="$refs['list-template'].search()" type="text">停用账号</el-button>
                        <el-button v-else v-confirm style="color:#67C23A;" :confirm-text="'确定启用账号？ '+data.nickname+'('+data.phone+') ?'" requestUrl="question/disabledUser.action" :confirm-data="{id:data.id,del:1}" @onConfirm="$refs['list-template'].search()" type="text">启用账号</el-button>
                    </el-col>
                    <el-col v-else :span="6" style="padding-left:40px;margin-top: 20px;">
                        <el-button v-if="data.del==1" style="color:#F56C6C;" v-confirm :confirm-text="'确定停用账号？停用后，该用户不能登录汽车网，不能发布信息等。 '+data.nickname+'('+data.phone+') ?'" requestUrl="question/disabledUser.action" :confirm-data="{id:data.id,del:2}" @onConfirm="$refs['list-template'].search()" type="text">停用账号</el-button>
                        <el-button v-else v-confirm style="color:#67C23A;" :confirm-text="'确定启用账号？ '+data.nickname+'('+data.phone+') ?'" requestUrl="question/disabledUser.action" :confirm-data="{id:data.id,del:1}" @onConfirm="$refs['list-template'].search()" type="text">启用账号</el-button>
                    </el-col>
                </el-row>
            </el-card>
        </div>
    </template>
</list-template>

</template>

<script>

import ChannelModel from '../../framework/models/channelModel'
import Config from '../../framework/configs/Config'
import BasicPager from '../../mixins/BasicPager'
import ListTemplate from '../../components/ListTemplate'
export default {
  name: 'question-user-management',
  extends: BasicPager,
  data: function () {
    return {
      showChannels: [],
      isAdmin: false,
      baseImageUrl: Config.imageUrl,
      startEndTime: null,
      searchInfo: {
        keyword: '',
        channelId: '',
        startTime: null,
        endTime: null
      }
    }
  },
  components: {
    ListTemplate
  },
  created: function () {
    let loginInfo = this.getLoginInfo()
    this.isAdmin = loginInfo.loginPath != 'channel'
    if (loginInfo.loginPath == 'channel') {
      this.searchInfo.channelId = loginInfo.id
    }

    this.findAllChannels()
  },
  methods: {
    onTimeChange: function (newValue) {
      if (newValue && newValue[0] && newValue[1]) {
        this.searchInfo.startTime = newValue[0].getTime()
        this.searchInfo.endTime = newValue[1].getTime()
      } else {
        this.searchInfo.startTime = null
        this.searchInfo.endTime = null
      }
      this.$refs['list-template'].search()
    },
    show: function (userId) {
      this.$router.push({
        name: '用户详情',
        params: {
          userId: userId
        }
      })
    },
    findAllChannels: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.showChannels = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    }

  }
}

</script>
